import { useEffect } from 'react';

import { useBoundStore } from 'app/store';

export const useInitCcrcInputs = ({ ccrcItemList }) => {
  const ccrcInputs = useBoundStore((store) => store['ccrcModal'].ccrcInputs);
  const setCcrcInputs = useBoundStore((store) => store['ccrcModal'].setCcrcInputs);
  const setInitCcrcInputs = useBoundStore((store) => store['ccrcModal'].setInitCcrcInputs);
  useEffect(() => {
    if (Object.keys(ccrcInputs).length <= 0) {
      setInitCcrcInputs(
        ccrcItemList.reduce((pv, cv) => {
          // 삼육대 강제 체크
          if (cv.ccrcGuidId === '33') {
            return pv;
          }

          return {
            ...pv,
            [cv.ccrcGuidId]: {
              checked: cv.ccrcDspYn === 'N',
              essnYn: cv.essnYn === 'Y',
            },
          };
        }, {}),
      );
    }
  }, []);

  return [ccrcInputs, setCcrcInputs];
};
